<template>
<CSidebar size="sm" position="fixed" :visible="sidebarVisible" @visible-change="( event )=>{
	$store.commit({'type': 'updateSidebarVisible', 'value': event})
}">
	<CSidebarBrand class="companyName">{{ user_info.companyName }}
		<p v-if="user_info.companyJoinStatus === 'I'" style="font-size: 0.7rem; margin: 0rem;">{{user_info.companyJoinStatus === 'I'?'(입점준비중)':''}}</p>
	</CSidebarBrand>
	<div class="d-flex flex-column flex-fill overflow-y-auto justify-content-between">
		<AppSidebarNav />
		<div class="d-flex flex-column">
			<SideBanner />
			<CButtonGroup data-agreement_wrap vertical>
				<CButton color="secondary" size="md" type="button">
					<a href="https://threelabs.notion.site/647efe0709a34bcca60e15b318d56329?pvs=4" target="_blank">광고상품 둘러보기</a>
				</CButton>
				<CButton color="secondary" size="md" type="button">
					<a href="https://forms.gle/xb4j8X4odSSDgCVv5" target="_blank">마켓뱅 이벤트 등록</a>
				</CButton>
				<CButton color="secondary" size="md" type="button" @click="useGuideOpen">이용가이드 바로가기</CButton>
				<a href="http://pf.kakao.com/_xcUYxnxj/chat" target="_blank" data-kakao_ch></a>
			</CButtonGroup>
		</div>
	</div>
</CSidebar>
</template>
<script setup>
import{ computed }from"vue";
import{ useStore }from"vuex";
import{ AppSidebarNav }from"./AppSidebarNav";
import SideBanner from"./SideBanner";

const store = useStore();
const sidebarVisible = computed(()=>store.state.sidebarVisible);
const user_info = computed(()=>store.state.user_info);
const useGuideOpen = ()=>window.open("//threelabs.notion.site/306abb65fdc8807c88acdd6e7610d4ae", "_blank");
</script>
<style lang="sass">
.sidebar
	--cui-sidebar-bg: #212631
</style>
<style scoped lang="sass">
[data-agreement_wrap]
	gap: 2px
	margin-bottom: 40px
	button
		height: 50px
		border-radius: 0
		font:
			size: 14px
			weight: 700
		color: #fff
	a
		text-decoration: none
		color: #fff
.companyName
	font:
		size: 16px
		weight: bold
[data-kakao_ch]
	width: 100%
	height: 50px
	margin-top: 20px
	background:
		size: contain
		position: center
		repeat: no-repeat
		image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='_레이어_1' data-name='레이어 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 480.31 133.55'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: none; stroke: %23efd923; stroke-miterlimit: 10; stroke-width: 3.06px; %7D .cls-2 %7B fill: %23040000; %7D .cls-3 %7B fill: %23efd923; %7D %3C/style%3E%3C/defs%3E%3Cg%3E%3Cpath class='cls-3' d='m66.4,19.68c-26.11,0-47.28,19.58-47.28,43.73,0,17.84,7.47,26.35,17.7,34.11l.05.02v20.93c0,.99,1.13,1.55,1.92.97l17.93-13.32.39.17c3.01.55,6.11.85,9.29.85,26.11,0,47.28-19.58,47.28-43.73s-21.17-43.73-47.28-43.73Z'/%3E%3Cg%3E%3Cpath class='cls-2' d='m93.09,58.05c1.75,1.8,2.63,4.24,2.63,7.4v14.95h-6.28v-14.17c0-3.26-1.9-5.02-4.82-5.02-3.26,0-5.36,2-5.36,6.04v13.15h-6.28v-34.66h6.28v13.04c1.51-2.29,3.94-3.41,7.26-3.41,2.68,0,4.87.88,6.57,2.68Z'/%3E%3Cpath class='cls-2' d='m60.34,67.43c-1.19,4.29-5.16,7.06-9.79,7.06-6.07,0-11.12-4.67-11.12-11.13s4.44-11.22,11.12-11.22c4.72,0,8.82,2.84,9.86,7.4h6.84c-1.6-8.39-8.06-13.9-16.7-13.9-9.94,0-17.81,7.41-17.81,17.72s7.88,17.72,17.81,17.72c8.55,0,14.97-5.41,16.65-13.65h-6.86Z'/%3E%3C/g%3E%3C/g%3E%3Crect class='cls-3' x='128.69' y='19.68' width='336.84' height='87.53' rx='24.05' ry='24.05'/%3E%3Cg%3E%3Cpath class='cls-2' d='m155.22,49.02h16.5v23.01h-16.5v-23.01Zm3.98,19.81h8.54v-16.61h-8.54v16.61Zm27.57-6.16h-5.5v18.17h-4.02v-35.26h4.02v13.77h5.5v3.32Z'/%3E%3Cpath class='cls-2' d='m202.57,58.89c-2.11,3.94-5.69,7.18-11.27,9.63l-1.95-2.89c4.72-1.99,7.76-4.52,9.56-7.57l-8.81.94-.55-3.28,10.65-.62c.31-1.09.55-2.22.66-3.43h-9.75v-3.24h13.77c0,2.61-.31,5.03-.98,7.22h4.52v-9.48h3.78v20.01h-3.78v-7.29h-5.85Zm6.75,9.36c0,4.37,4.84,8.27,11.7,9.28l-1.56,3.16c-5.46-.9-9.95-3.55-12.13-7.22-2.22,3.67-6.67,6.32-12.17,7.22l-1.52-3.16c6.79-1.01,11.66-4.91,11.66-9.28v-.9h4.02v.9Zm9.98,1.09h-3.82v-23.75h3.82v23.75Z'/%3E%3Cpath class='cls-2' d='m239.77,64.58h-13.77v-16.54h3.78v5.19h6.24v-5.19h3.74v16.54Zm-3.74-8.19h-6.24v4.95h6.24v-4.95Zm18.56,17.94c0,4.06-4.6,6.51-11.93,6.51s-11.93-2.46-11.93-6.51,4.64-6.55,11.93-6.55,11.93,2.42,11.93,6.55Zm-4.02,0c0-2.22-2.96-3.43-7.92-3.43s-7.92,1.21-7.92,3.43,2.96,3.39,7.92,3.39,7.92-1.21,7.92-3.39Zm-3.71-8.31h-3.78v-19.77h3.78v8.31h3.71v-8.97h3.82v21.49h-3.82v-9.2h-3.71v8.15Z'/%3E%3Cpath class='cls-2' d='m283.63,68.6c1.64-.16,3.28-.31,4.84-.51l.23,2.96c-7.29,1.21-15.44,1.33-21.57,1.33l-.43-3.31h4.33v-16.69h-3.43v-3.24h19.46v3.24h-3.43v16.22Zm-8.7.43c1.56-.04,3.2-.12,4.8-.19v-16.46h-4.8v16.65Zm24.96-6.36h-5.5v18.17h-4.02v-35.26h4.02v13.77h5.5v3.32Z'/%3E%3Cpath class='cls-2' d='m334.37,73.2v3.28h-31.94v-3.28h31.94Zm-3.59-5.77h-24.42v-18.99h24.14v3.24h-20.05v4.52h19.27v3.16h-19.27v4.84h20.32v3.24Z'/%3E%3Cpath class='cls-2' d='m343.57,69.1c4.88-.04,9.59-.43,14.55-1.4l.47,3.31c-5.62,1.09-10.76,1.44-16.19,1.44h-2.81v-23.01h3.98v19.66Zm23.4-23.52v35.3h-4.02v-20.71h-10.22v-3.28h10.22v-11.31h4.02Z'/%3E%3C/g%3E%3Ccircle class='cls-2' cx='413.69' cy='63.45' r='22'/%3E%3Cg%3E%3Cline class='cls-1' x1='413.69' y1='51.78' x2='413.69' y2='75.12'/%3E%3Cline class='cls-1' x1='425.36' y1='63.45' x2='402.02' y2='63.45'/%3E%3C/g%3E%3C/svg%3E")
.sidebar-nav
	flex: 0
	overflow: visible
</style>